module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/84070122c90e749d26965a09de1b9e8e.png";